import { hasProperty, isEmpty } from "./../validate";

export const getFormHandle = (form) => {
	let handle = null;

	if (!isEmpty(form)) {
		if (hasProperty(form, 'handle')) {
			handle = form.handle;
		} else {
			handle = form;
		}
	}

	return handle;
}

export const getFormAttribute = (formData, attribute) => {

	if (!isEmpty(formData)) {
		if (hasProperty(formData.form, "formProperties")) {
			const form = formData.form;
			if (hasProperty(form.formProperties, "form") && hasProperty(form.formProperties.form, "tagAttributes") && form.formProperties.form.tagAttributes.length > 0) {
				let attributeObject = form.formProperties.form.tagAttributes.find(el => {
					return el.attribute === attribute
				})
				if (attributeObject) {
					return attributeObject.value
				 }
			}
		}
	}

	return null;
}

export const getFieldAttribute = (field, type, value) => {
	const attributes = ['input', 'label', 'error', 'instruction'];
	let payload;

	if (type != undefined || type != 'undefined') {
		let found = attributes.find(el => el == type);
		if (found) {
			let attributeType = `${type}Attributes`;
			if (hasProperty(field, attributeType)) {
				let attributeObject = field[attributeType].find(el => el.attribute === value)
				if (attributeObject) {
					payload = attributeObject.value
				}
			}
		} else {
			throw 'INVALID_ATTRIBUTE_TYPE';
		}
	}
	return payload;
}

export const getFieldAttributes = (field, type, value) => {
	const attributes = ['input', 'label', 'error', 'instruction'];
	let payload = [];

	if (type != undefined || type != 'undefined') {
		let found = attributes.find(el => el == type);
		let attributeType = `${type}Attributes`;
		if (found) {
			if (hasProperty(field, attributeType)){
				let attributeObjects = field[attributeType].filter(el => el.attribute === value)
				 payload = attributeObjects;
			}
		}
	}

	return payload;
}

export const getLabelAttribute = (field, value) => {
	let payload;
	if (hasProperty(field, 'labelAttributes')) {
		let attribute = field.labelAttributes.find(el => el.attribute === value)
		if (attribute) {
			payload = attribute.value
		}
	}
	return payload;
}

export const getInputAttribute = (field, value) => {
	let payload;
	if (hasProperty(field, 'inputAttributes')) {
		let attribute = field.inputAttributes.find(el => el.attribute === value)
		if (attribute) {
			payload = attribute.value
		}
	}
	return payload;
}

export const formatPostalCode = (code) => {
	return code;
}

export const minValue = (field) => {
	let minValue = 0;
	let allowNegative = field.allowNegative;
	if (allowNegative) {
		minValue = "";
	} else {
		if (field.minValue >= 0) {
			minValue = field.minValue;
		}
	}

	return minValue;
}

export const maxValue = (field) => {
	let maxValue = 0;

	if (field.maxValue > 0) {
		maxValue = field.maxValue;
	} else {
		maxValue = "";
	}

	return maxValue;
}

export function extractBirthdayFromId(idNumber){
	let Year = idNumber.substring(0, 2);
	let Month = idNumber.substring(2, 4)
	let Day = idNumber.substring(4, 6)
	let cutoff = (new Date()).getFullYear() - 2000
	let dob = (Year > cutoff ? '19' : '20') + Year + '/' + Month + '/' + Day;
	return dob;
}

export function formatDate(date){
	let d = new Date(date)
	let year = d.getFullYear();
	let month = d.getMonth();
	let day = d.getDate();
	month = month + 1;
	let returnDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
	return returnDate;
}

export function calculateAge(birthday) { // birthday is a date
	let dob = new Date(birthday);
    let ageDifMs = Date.now() - dob.getTime();
    let ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function extractGenderFromId(idNumber){
	let gender = "";
	let genderNumber = idNumber.substring(6, 10);
	if (genderNumber.length === 4){
		let genderCode = parseInt(genderNumber);
		if (!isNaN(genderCode)){
			if (genderCode >= 0 && genderCode <= 4999){
				gender = 'F'
			}
			if (genderCode >= 5000 && genderCode <= 9999){
				gender = 'M'
			}
		}
	}
	return gender;
}